import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { useContext } from 'react';
import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useNativeDeviceType } from '~/context/common/DeviceContext';
import { useConfiguration } from '~/context/common/StaticContext';
import {
  useIsLoggedIn,
  useUserId,
  useUserLocation
} from '~/context/common/UserContext';
import ModalContext from '~/context/home/ModalContext';
import { useResizeListener, useTrackClickEvents } from '~/hooks/common';
import { useTrackCreditKarmaPromo } from '~/hooks/common/creditKarmaPromo';
import { useGetFavorites } from '~/hooks/common/favorites';
import { useGetDiscountData } from '~/hooks/common/services';
import useDataDogRUM from '~/hooks/common/useDataDogRUM';
import useGetTrades from '~/hooks/common/useGetTrades';
import useModalScrollRestoration from '~/hooks/common/useModalScrollRestoration';
import useSynchronizeAuth from '~/hooks/common/useSynchronizeAuth';
import useConvertRecentToSearch from '~/hooks/home/useConvertRecentToSearch';
import useGetBulkAvailability from '~/hooks/home/useGetBulkAvailability';
import useGetBulkPricing from '~/hooks/home/useGetBulkPricing';
import useGetCreditStatus from '~/hooks/home/useGetCreditStatus';
import useGetRecentSearches from '~/hooks/home/useGetRecentSearches';
import useGetRecentVehicles from '~/hooks/home/useGetRecentVehicles';
import useGetSavedSearches from '~/hooks/home/useGetSavedSearches';
import useGetSuggestedForYou from '~/hooks/home/useGetSuggestedForYou';
import useGetUserPurchase from '~/hooks/home/useGetUserPurchase';
import useSendViewedEvent from '~/hooks/home/useSendViewedEvent';
import useSetDataDogContext from '~/hooks/home/useSetDataDogContext';
import useTrackMegaVehicle from '~/hooks/home/useTrackMegaVehicle';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/home';

export default function HomeData() {
  const isLoggedIn = useIsLoggedIn();
  const nativeDeviceType = useNativeDeviceType();
  const { isAnyModalOpen } = useContext(ModalContext);
  const { state: stateAbbreviation } = useUserLocation();
  const { showCkPromo = false } = useConfiguration();
  const userId = useUserId();

  useConvertRecentToSearch();
  useDataDogRUM();
  useSynchronizeAuth();
  useSendViewedEvent();
  useGetCreditStatus(isLoggedIn);
  useResizeListener(legacySizes);
  useGetDiscountData({
    shouldFetch: showCkPromo,
    stateAbbreviation,
    userId
  });
  useGetRecentSearches();
  useGetRecentVehicles();
  useGetSuggestedForYou();
  useGetUserPurchase();
  useGetFavorites();
  useSetDataDogContext();
  useGetSavedSearches();
  useGetTrades(isLoggedIn);
  useTrackClickEvents();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);
  useModalScrollRestoration(isAnyModalOpen);
  useGetBulkAvailability();
  useGetBulkPricing();
  useTrackCreditKarmaPromo();
  useTrackMegaVehicle();

  return null;
}
